import { MenuConfig, menuConfig, MenuConfigFn } from '@apis/generate-config'

export type GenerateLTIXMLParams = {
  type: keyof typeof menuConfig
} & MenuConfig

const BASE_URL = process.env.NEXT_PUBLIC_CANVAS_LTI_APP_URL!

const generateBLTI = (moduleName: keyof typeof menuConfig, cfg: MenuConfig) => {
  let configFn: MenuConfigFn = menuConfig['default']
  let config: ReturnType<MenuConfigFn> = configFn(cfg)

  configFn = menuConfig[moduleName] || menuConfig.default
  config = configFn({ id: cfg.id, ...cfg })

  return `
  <blti:title>${config.title}</blti:title>
  <blti:description>${config.description}</blti:description>
  <blti:launch_url>${BASE_URL + config.launchUrl}</blti:launch_url>
  <blti:extensions platform="canvas.instructure.com">
    <lticm:property name="privacy_level">${config.privacyLevel}</lticm:property>
    <lticm:options name="course_navigation">
      <lticm:property name="visibility">${
        config.courseNavigation.visibility || 'public'
      }</lticm:property>
      <lticm:property name="url">${
        BASE_URL + config.courseNavigation.url
      }</lticm:property>
      <lticm:property name="text">${
        config.courseNavigation.text
      }</lticm:property>
      <lticm:property name="enabled">${
        config.courseNavigation.enabled
      }</lticm:property>
      <lticm:options name="custom_fields">
        <lticm:property name="custom_course_sis_id">$Context.sourcedId</lticm:property>
      </lticm:options>
    </lticm:options>
  </blti:extensions>
  `
}

export const generateLTIXML = ({ type, ...params }: GenerateLTIXMLParams) => {
  return `
<cartridge_basiclti_link
  xmlns="http://www.imsglobal.org/xsd/imslticc_v1p0"
  xmlns:blti="http://www.imsglobal.org/xsd/imsbasiclti_v1p0"
  xmlns:lticm="http://www.imsglobal.org/xsd/imslticm_v1p0"
  xmlns:lticp="http://www.imsglobal.org/xsd/imslticp_v1p0"
  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.imsglobal.org/xsd/imslticc_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imslticc_v1p0.xsd http://www.imsglobal.org/xsd/imsbasiclti_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imsbasiclti_v1p0.xsd http://www.imsglobal.org/xsd/imslticm_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imslticm_v1p0.xsd http://www.imsglobal.org/xsd/imslticp_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imslticp_v1p0.xsd">
  ${generateBLTI(type, params)}    
</cartridge_basiclti_link>
`
}
